exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".profile-img-area[data-v-76987270]{border:2px solid #fff;overflow:hidden;margin:auto;border-radius:50%;background-image:url(/img/gnb/empty_profile.png);background-size:100%}.original-image-area[data-v-76987270]{position:fixed;width:100%;top:0;left:0;height:100%;background-color:rgba(0,0,0,.8);display:none;z-index:2000}", ""]);

